import { useEffect } from 'react';
import { LandingHeader } from './LandingHeader';
import { HeroSection } from './HeroSection';
import { analytics } from '../../services/analytics';
import { TrustBar } from './TrustBar';
import { AppShowcaseSection } from './sections/AppShowcaseSection';
import { FreeAndPrivateSection } from './sections/FreeAndPrivateSection';
import { DailyPracticeSection } from './sections/DailyPracticeSection';
import { TwelveStepSection } from './sections/TwelveStepSection';
import { SponsorSection } from './sections/SponsorSection';
import { WhoItsForSection } from './sections/WhoItsForSection';
import { PricingSection } from './sections/PricingSection';
import LandingFooter from './LandingFooter';

export default function LandingPage() {
  useEffect(() => {
    analytics.landingPageViewed();
  }, []);

  return (
    // Force dark mode on landing page — it has its own fixed dark aesthetic
    // independent of the user's in-app theme preference.
    <div className="dark min-h-screen bg-[#0D1321]">
      <LandingHeader />
      <main>
        <HeroSection />
        <TrustBar />
        <AppShowcaseSection />
        <FreeAndPrivateSection />
        <DailyPracticeSection />
        <TwelveStepSection />
        <SponsorSection />
        <WhoItsForSection />
        <PricingSection />
      </main>
      <LandingFooter />
    </div>
  );
}
